import * as Constants from '@emi/shared/constants';

export default function convertUnit(value: number, inputType: string, expectedType: string) {
    const inputTypeConstant: number = getTypeConstant(inputType);
    const baseUnitValue: number = value * inputTypeConstant;
    const expectedUnitConstant: number = getTypeConstant(expectedType);
    const convertedUnit: number = calculateUnit();

    function getTypeConstant(typeToCheck: string) {
        switch (typeToCheck) {
            case 'fl oz':
                return Constants.VolumeToMilligramsConstants.FLUID_OUNCE;

            case 'pt':
                return Constants.VolumeToMilligramsConstants.PINT;

            case 'l':
                return Constants.VolumeToMilligramsConstants.LITRE;

            case 'cl':
                return Constants.VolumeToMilligramsConstants.CENTILITRE;

            case 'gal':
                return Constants.VolumeToMilligramsConstants.GALLON;

            case 'ml':
                return Constants.VolumeToMilligramsConstants.MILLILITRE;

            case 'oz':
                return Constants.WeightToMilligramsConstants.OUNCE;

            case 'mg':
                return Constants.WeightToMilligramsConstants.MILLIGRAM;

            case 'kg':
                return Constants.WeightToMilligramsConstants.KILOGRAM;

            case 'lb':
                return Constants.WeightToMilligramsConstants.POUND;

            case 'g':
                return Constants.WeightToMilligramsConstants.GRAM;
            default:
                return 0;
        }
    }

    function calculateUnit() {
        return baseUnitValue / expectedUnitConstant;
    }

    return convertedUnit;
}
